import Reveal, { SectionHead } from "./Reveal";

const HEADLINES = [
  "Your Church Is Not Dying. It May Be Digitally Invisible.",
  "The People You Are Praying For May Be Searching for You Right Now.",
  "A Church With No Digital Presence Is a Lighthouse With Its Light Turned Off.",
  "Your Next Member May Never Drive Past Your Building — But They Will Scroll Past Your Church.",
  "Sunday Is Not the Only Day People Need a Word From God.",
  "The Gospel Has Not Lost Power. But Your Church May Have Lost Visibility.",
  "You Do Not Need to Compromise the Message to Modernize the Method.",
  "Make God, the Kingdom, and Your Church Relevant Again.",
];

export default function Campaign() {
  return (
    <section id="campaign" data-testid="campaign-section" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-8 bg-navy-surface/40">
      <div className="max-w-7xl mx-auto">
        <SectionHead eyebrow="The Campaign" title="The Church Is Still Here. Now Let the City Know."
          sub="An outreach campaign designed to awaken pastors and church leaders to the cost of being digitally invisible — without shaming them." />
        <div className="mt-12" data-testid="campaign-headlines">
          {HEADLINES.map((h, i) => (
            <Reveal key={i} delay={Math.min(i * 0.04, 0.3)}>
              <div className="group flex items-baseline gap-5 border-t border-gold/15 py-6 transition-all duration-300 hover:pl-4">
                <span className="font-display text-2xl text-gold/30 group-hover:text-gold transition-colors shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="font-display text-lg sm:text-2xl uppercase tracking-tight text-slate-300 group-hover:text-white transition-colors">
                  {h}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <div className="mt-14 rounded-lg border-l-4 border-gold bg-navy-surface p-8 sm:p-10" data-testid="lighthouse-script">
            <p className="text-[10px] tracking-[0.3em] uppercase text-gold font-faith mb-5">The “Lighthouse” — 60-Second Film</p>
            <p className="font-cormorant italic text-lg sm:text-2xl text-amber-100/90 leading-relaxed">
              “A church without a digital presence is like a lighthouse with its light turned off. The building is
              there. The message is there. The people are there. But the city cannot see it… Your church was never
              called to be invisible. Let the city know the Church is still here.”
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
